import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { FormField } from './form-field';
import { errorDisplayFunction } from 'src/app/app.types';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { ObjectKeysPipe } from '../object-keys.pipe';

@Component({
  selector: 'qa-form-field-enum',
  templateUrl: './enum.component.html',
  styleUrls: ['./enum.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    FormsModule,
    ReactiveFormsModule,
    MatOption,
    MatError,
    TranslateModule,
    ObjectKeysPipe,
  ],
})
export class FormSelectEnumComponent extends FormField implements OnInit {
  @Input()
  options: {};

  @Input()
  displayFn: (instance: {}) => string;

  displayControl = new UntypedFormControl();

  displayOptions;
  displayOptionsKeys;

  optionsKeys: string[];

  errorDisplayFunction = errorDisplayFunction;

  constructor() {
    super();
  }

  defaultDisplayFn(input: {}) {
    return '' + input;
  }

  updateDisplayValue() {
    this.displayControl.setValue(this.control.value, { emitEvent: false });
  }

  ngOnInit() {
    this.displayFn = this.displayFn || this.defaultDisplayFn;

    this.displayOptions = this.options;
    this.displayOptionsKeys = Object.keys(this.displayOptions).filter(
      (key, index) => {
        return +key !== index;
      }
    );

    this.control.valueChanges.subscribe(() => this.updateDisplayValue());

    this.displayControl.valueChanges.subscribe((value) => {
      this.control.reset();
      this.control.patchValue(value);
      this.control.markAsTouched();
      this.control.markAsDirty();
    });

    this.updateDisplayValue();
  }
}
